import Range from "exceljs/lib/doc/range";

export const formatDate = ({ obj }) => {
  //return obj === null ? "" : new Date(`${obj}T00:00`);
  return obj === null ? "" : new Date(`${obj}`);
};
export const getBase64FromUrl = async (url) => {
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
  });
};
export const createLogo = ({
  image,
  width,
  height,
  colid,
  rowid,
  workbook,
  worksheet,
}) => {
  const imageLogo = workbook.addImage({
    base64: image,
    extension: "JPG",
  });
  if (image !== "") {
    worksheet.addImage(imageLogo, {
      tl: { col: colid, row: rowid },
      ext: { width: width, height: height },
    });
  }
};
export const alingHeadertext = {
  wrapText: true,
  horizontal: "center",
  vertical: "middle",
};
export const fontHeadertext = ({
  fontSize,
  fontName = "Arial",
  isBold = false,
}) => ({
  size: fontSize,
  bold: isBold,
  name: fontName,
});
export const fillHeadertext = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "ffccffff" },
};
export const borderHeadertext = {
  top: { style: "thin", color: { argb: "ff000000" } },
  left: { style: "thin", color: { argb: "ff000000" } },
  bottom: { style: "thin", color: { argb: "ff000000" } },
  right: { style: "thin", color: { argb: "ff000000" } },
};
export const styleNumber = { numFmt: "#,##0.00;[Red]-#,##0;-" };